import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Home, CreditCard } from "lucide-react";
import { confirmSubscription } from "@/services/subscriptionService";
import liveLogo from "@/assets/live-stay-logo.png";
import Footer from "@/components/Footer";

const AssinaturaConfirmada = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const status = searchParams.get("status");
  const preapprovalId = searchParams.get("preapproval_id");
  const isSuccess = status === "success" || !!preapprovalId;

  // Quando o MP redireciona de volta com preapproval_id, confirma a
  // assinatura no backend para vincular o preapproval_id ao usuário logado.
  useEffect(() => {
    if (preapprovalId) {
      confirmSubscription(preapprovalId);
    }
  }, [preapprovalId]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-orange-50/30 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950 flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-10 bg-white/80 dark:bg-slate-900/80 backdrop-blur-md border-b border-slate-200 dark:border-slate-800">
        <div className="container mx-auto px-4 h-16 flex items-center">
          <button
            onClick={() => navigate("/")}
            aria-label="Ir para a página inicial"
          >
            <img src={liveLogo} alt="LiveStay" className="h-9 w-auto" />
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-md w-full text-center space-y-8">
          {isSuccess ? (
            <>
              <div className="flex justify-center">
                <div className="rounded-full bg-green-100 dark:bg-green-900/30 p-6">
                  <CheckCircle2 className="h-16 w-16 text-green-600 dark:text-green-400" aria-hidden="true" />
                </div>
              </div>

              <div className="space-y-3">
                <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100">
                  Assinatura confirmada!
                </h1>
                <p className="text-slate-600 dark:text-slate-400 text-lg">
                  Bem-vindo ao plano <span className="font-semibold text-orange-600 dark:text-orange-400">Live</span>. Seu acesso está sendo ativado.
                </p>
                <p className="text-sm text-slate-500 dark:text-slate-500">
                  Em instantes você terá acesso completo a todas as funcionalidades. Pode levar alguns segundos para o sistema atualizar.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Button
                  size="lg"
                  className="bg-orange-500 hover:bg-orange-600 text-white gap-2"
                  onClick={() => navigate("/minha-area/meus-imoveis")}
                >
                  <Home className="h-4 w-4" aria-hidden="true" />
                  Ir para Minha Área
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="gap-2"
                  onClick={() => navigate("/minha-area/minha-assinatura")}
                >
                  <CreditCard className="h-4 w-4" aria-hidden="true" />
                  Ver assinatura
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className="flex justify-center">
                <div className="rounded-full bg-slate-100 dark:bg-slate-800 p-6">
                  <XCircle className="h-16 w-16 text-slate-400" aria-hidden="true" />
                </div>
              </div>

              <div className="space-y-3">
                <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100">
                  Assinatura cancelada
                </h1>
                <p className="text-slate-600 dark:text-slate-400">
                  O processo de assinatura foi cancelado. Nenhuma cobrança foi realizada.
                </p>
              </div>

              <Button
                size="lg"
                className="bg-slate-800 hover:bg-slate-900 text-white gap-2"
                onClick={() => navigate("/minha-area/assinar-live")}
              >
                Tentar novamente
              </Button>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AssinaturaConfirmada;
